import { makeStyles, Dialog, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core'
import PropTypes from 'prop-types'
import QuestionHeader from './questionHeader'
import { addHTTP } from 'utils/utils'
import { useState } from 'react'

const useStyles = makeStyles(() => ({
  url: {
    whiteSpace: 'nowrap',
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  iframe: {
    width: '100%',
    border: 'none'
  }
}))


export default function RenderIframe({ elmIndex, elm }) {
  const classes = useStyles()
  const [inFrame, setInFrame] = useState(false)
  const [hasClicked, setHasClicked] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)

  let url = addHTTP(elm.URL)
  const urlParams = new URLSearchParams(decodeURIComponent(elm?.URL?.split('?')?.[1] ?? ''))

  const mouseLeave = () => {
    setInFrame(false)
    if (!hasClicked) return
    if (elm.ExitMessage) setOpenDialog(true)
    setHasClicked(false)
  }
  window.addEventListener('blur', () => setHasClicked(!!inFrame))

  // YouTube Embed
  if (url?.indexOf('youtube.com/watch') > 0) {
    url = 'https://www.youtube.com/embed/' + urlParams.get('v')
  } else if (url?.indexOf('youtu.be') > 0) {
    url = 'https://www.youtube.com/embed/' + url.split('youtu.be/')[1].split('/')[0]
  }

  let src = url
  if (elm.Proxy) {
    if (elm.UIF) src = `https://ultraiframe.simplemnt.com?h=${(elm.Height || 550) - 50}&u=${url}`
    else src = `https://us-central1-horatio-project.cloudfunctions.net/proxy/${url.substring(8)}`
  }

  return <div key={elmIndex}>
    <QuestionHeader helpTooltip={elm.ShowHelpTooltip ? elm.HelpTooltip : ''} prompt={elm.Prompt} allowBlanks={true} />
    {!elm.HideURL && <p className={classes.url}><a href={url} target="_blank" rel="noopener noreferrer">{elm.URL}</a></p>}
    <div onMouseLeave={mouseLeave} onMouseEnter={() => setInFrame(true)}>
      <iframe className={classes.iframe} style={{ height: `${elm.Height && Number.isInteger(parseInt(elm.Height)) ? elm.Height : '1000'}px` }} src={src} />
    </div>
    <Dialog fullWidth={true} maxWidth='xs' open={openDialog} onClose={() => setOpenDialog(false)}>
      <DialogContent>
        <DialogContentText>
          {elm.ExitMessage}
        </DialogContentText>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="primary">Close</Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  </div>
}

RenderIframe.propTypes = {
  elmIndex: PropTypes.number.isRequired,
  elm: PropTypes.object.isRequired,
}